import Vue from "vue";
import Router from "vue-router";
import login from "@/components/authentication/login";
import dashboard from "@/components/dashboard/dashboard";
import RNPLDashboard from "@/components/dashboard/RNPLDashboard";
import dashboardFrame from "@/components/dashboard/dashboardFrame";
import RNPLDashboardFrame from "@/components/dashboard/RNPLDashboardFrame";
import listing from "@/components/dashboard/listing";
import listingDetail from "@/components/dashboard/listingDetails";
import member from "@/components/dashboard/members";
import referral from "@/components/dashboard/referral";
import referrerDetail from "@/components/dashboard/referralDetails";
import teamMembers from "@/components/dashboard/teamMembers";
import invoice from "@/components/dashboard/invoices";
import memberDetail from "@/components/dashboard/memberDetails";
import booking from "@/components/dashboard/booking";
import bookingDetail from "@/components/dashboard/bookingDetails";
import subscription from "@/components/dashboard/subscription";
import settlements from "@/components/dashboard/settlement";
import loans from "@/components/dashboard/loans";
import loansRequest from "@/components/dashboard/loanRequest";
import disbursement from "@/components/dashboard/loanDisbursement";
import loanDetail from "@/components/dashboard/loanDetails";
import verifyRequests from "@/components/dashboard/verifyRequests";
import verifyDetails from "@/components/dashboard/verifyDetails";
import subscriptionDetail from "@/components/dashboard/subscriptionDetails";
import maintenance from "@/components/dashboard/maintenance";
import maintenanceDetail from "../components/dashboard/maintenanceDetail";
import error from "../components/general/error";
import setAdminPassword from "../components/authentication/set-password";
import ForgotPassword from "../components/authentication/forgot-password/forgot-password";
import ResetPasswordSent from "../components/authentication/forgot-password/email-sent";
import ChangePasword from "../components/authentication/forgot-password/change-password";
import VueCookies from "vue-cookies";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "login",
      component: login,
      meta: {
        guest: true,
        title: "Admin | Login"
      }
    },
    {
      path: "/dashboard",
      component: dashboardFrame,
      children: [
        {
          path: "",
          name: "dashboard",
          component: dashboard,
          meta: {
            requiresAuth: true,
            title: "Admin | Dashboard"
          }
        },
        {
          path: "/listing",
          name: "listing",
          component: listing,
          meta: {
            requiresAuth: true,
            title: "Admin | Listings"
          }
        },
        {
          path: "/listing-details/:id",
          name: "listingDetail",
          component: listingDetail,
          meta: {
            requiresAuth: true,
            title: "Admin | Listing details"
          }
        },
        {
          path: "/members",
          name: "member",
          component: member,
          meta: {
            requiresAuth: true,
            title: "Admin | Members"
          }
        },

        {
          path: "/member-details/:id",
          name: "memberDetail",
          component: memberDetail,
          meta: {
            requiresAuth: true,
            title: "Admin | Member details"
          }
        },
        {
          path: "/team-members",
          name: "teamMembers",
          component: teamMembers,
          meta: {
            requiresAuth: true,
            title: "Admin | Team Members"
          }
        },
        {
          path: "/booking",
          name: "booking",
          component: booking,
          meta: {
            requiresAuth: true,
            title: "Admin | Bookings"
          }
        },
        {
          path: "/booking-details/:id",
          name: "bookingDetail",
          component: bookingDetail,
          meta: {
            requiresAuth: true,
            title: "Admin | Booking details"
          }
        },
        {
          path: "/referral",
          name: "referral",
          component: referral,
          meta: {
            requiresAuth: true,
            title: "Admin | Referrals"
          }
        },
        {
          path: "/referrer-details/:id",
          name: "referrerDetail",
          component: referrerDetail,
          meta: {
            requiresAuth: true,
            title: "Admin | Referrer details"
          }
        },
        {
          path: "/subscription",
          name: "subscription",
          component: subscription,
          meta: {
            requiresAuth: true,
            title: "Admin | Subscription"
          }
        },
        {
          path: "/subscription-details/:id",
          name: "subscriptionDetail",
          component: subscriptionDetail,
          meta: {
            requiresAuth: true,
            title: "Admin | Subscription details"
          }
        },
        {
          path: "/invoices",
          name: "invoices",
          component: invoice,
          meta: {
            requiresAuth: true,
            title: "Admin | Invoices"
          }
        },
        {
          path: "/maintenance",
          name: "maintenance",
          component: maintenance,
          meta: {
            requiresAuth: true,
            title: "Spleet | Maintenance"
          }
        },
        {
          path: "/maintenance/:id",
          name: "maintenanceDetail",
          component: maintenanceDetail,
          meta: {
            requiresAuth: true,
            title: "Spleet | Maintenance detail"
          }
        },
        {
          path: "/settlements",
          name: "settlements",
          component: settlements,
          meta: {
            requiresAuth: true,
            title: "Admin | settlements"
          }
        },
        {
          path: "/verify",
          name: "verifyRequests",
          component: verifyRequests,
          meta: {
            requiresAuth: true,
            title: "Admin | verify"
          }
        },
        {
          path: "/verify-details/:id",
          name: "verifyDetails",
          component: verifyDetails,
          meta: {
            requiresAuth: true,
            title: "Admin | Verify details"
          }
        },
        {
          path: "*",
          component: error,
          name: "lost",
          meta: {
            title: "Spleet | You are lost"
          }
        },
        {
          path: "/lost",
          component: error,
          name: "lost-two",
          meta: {
            title: "Spleet | You are lost"
          }
        }
      ]
    },
    {
      path: "/rnpl-dashboard",
      component: dashboardFrame,
      children: [
        {
          path: "",
          name: "/rnpl/dashboard",
          component: RNPLDashboard,
          meta: {
            requiresAuth: true,
            title: "Admin | RNPL Dashboard"
          }
        }
      ]
    },
    {
      path: "/",
      component: dashboardFrame
    },
    {
      path: "/rnpl",
      component: RNPLDashboardFrame,
      children: [
        {
          path: "",
          name: "rnpl",
          component: RNPLDashboard,
          meta: {
            requiresAuth: true,
            title: "Admin | RNPL Dashboard"
          }
        },
        {
          path: "/loan-request",
          name: "loan-request",
          component: loansRequest,
          meta: {
            requiresAuth: true,
            title: "Admin | loan-request"
          }
        },

        {
          path: "/disbursement",
          name: "disbursement",
          component: disbursement,
          meta: {
            requiresAuth: true,
            title: "Admin | disbursement"
          }
        },
        {
          path: "/loans",
          name: "loans",
          component: loans,
          meta: {
            requiresAuth: true,
            title: "Admin | loans"
          }
        },
        {
          path: "/loan-details/:id",
          name: "loans",
          component: loanDetail,
          meta: {
            requiresAuth: true,
            title: "Admin | loan details"
          }
        }
      ]
    },
    {
      path: "/set-password/:id",
      name: "set-password",
      component: setAdminPassword,
      meta: {
        requiresAuth: false,
        title: "Admin | Set Admin password"
      }
    },
    {
      path: "/change-password/:id",
      name: "change-password",
      component: ChangePasword,
      meta: {
        requiresAuth: false,
        title: "Admin | Forgot password"
      }
    },

    {
      path: "/forgot-password",
      name: "forgot-password",
      component: ForgotPassword,
      meta: {
        requiresAuth: false,
        title: "Admin | Forgot password"
      }
    },
    {
      path: "/email-sent",
      name: "email-sent",
      component: ResetPasswordSent,
      meta: {
        requiresAuth: false,
        title: "Admin | Forgot password"
      }
    },
    {
      path: "*",
      component: error,
      name: "lost",
      meta: {
        title: "Spleet | You are lost"
      }
    }
  ],
  scrollBehavior() {
    document.getElementById("app").scrollIntoView();
  }
});

router.beforeEach((to, from, next) => {
  let admin = VueCookies.get("admin");
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!admin) {
      return next({
        path: "/",
        query: { redirect: to.fullPath }
      });
    } else {
      return next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (admin) {
      return next("/dashboard");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js